import { defineMessages } from 'react-intl';

export const messages: {
	searchIconLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	searchIconLabel: {
		id: 'dynamic-cards-search-page.dropdown_search_icon_label',
		defaultMessage: 'Search',
		description:
			'Label text for search icon shown in search input where user can click to type search query',
	},
});
